<div class="rating-wrap">

  @if (showNumber) {
    <div
      class="score"
      [ngClass]="{ pulse: showScore }"
    >
      {{ value }}
    </div>
  }

  <div class="rating" [ngClass]="{'small-size': smallSize}">

    @for (star of counter(max); track $index) {

      <ion-icon
        class="star-icon {{ star }}"
        color="warning"
        [name]="$index < (value || 0) ? 'star' : 'star-outline'"
        (click)="setScore($index)"
      ></ion-icon>

    }

  </div>

</div>
